
import intersectionObserver from "@/mixins/intersectionObserver"
import themes from "@/mixins/themes"
import media from "@/mixins/media"
import { mdiVolumeHigh, mdiVolumeOff } from "@mdi/js"

export default {
    name: "JobPageMedia",
    components: {
        ResponsiveVimeo: () =>
            import("@/components/base/video/ResponsiveVimeo"),
        OImage: () => import("@/components/base/image/OImage"),
        OPicture: () => import("@/components/base/image/OPicture"),
        Button: () => import("@/components/base/Button"),
    },
    mixins: [intersectionObserver, themes, media],
    props: {
        /** Either video or image object */
        media: {
            type: Object,
            default: null,
        },
        /** Enables blurred layout and sets media to be contained in it */
        enableLayout: {
            type: Boolean,
            default: true,
        },
        /** Duration of the background fade transition in ms */
        transitionDuration: {
            type: Number,
            default: 500,
            validator: (val) => val >= 0,
        },
        muted: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        hasAudio: false,
        isVideoMuted: true,
    }),
    icons: {
        mdiVolumeHigh,
        mdiVolumeOff,
    },
    computed: {
        transitionStyles() {
            return {
                "transition-duration": `${this.transitionDuration}ms`,
            }
        },
        alt() {
            return this.media?.file_name ?? ""
        },
    },
    methods: {
        onVimeoReady({ hasAudio }) {
            this.hasAudio = hasAudio
            this.observeIntersection(
                this.$refs["video-player"].$el,
                () => {
                    this.$refs["video-player"]?.playVideo()
                },
                () => {
                    this.$refs["video-player"]?.pauseVideo()
                },
                {
                    threshold: 0.4,
                }
            )
        },
    },
}
